import { Injectable } from '@angular/core';
import { ApiService } from '@shared';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CandidateExtraInfo } from '@shared/models/candidate-extra-info';

@Injectable()
export class CandidateExtraInfoService extends ApiService<CandidateExtraInfo> {
  constructor(http: HttpClient) {
    super(http);
    this.url = 'candidate';
  }

  loadExtraInfoForCandidates(candidateIds: number[]): Observable<CandidateExtraInfo[]> {
    const ids = candidateIds.join(',');
    return this.get({ url: `/extra-info?candidateIds=${ids}` });
  }
}
